import { DialogService } from 'app/services/dialog.service';
import { ChangeDetectorRef, Component, ComponentRef, inject, Injector, ViewChild, ViewContainerRef } from '@angular/core';
import { ReportTemplateService } from '../../../../services/reporttemplate.service';
import { DialogBaseComponent } from "../../base-admin-panel/dialog-base/dialog-base.component";
import { ReportTemplateViewModel } from '../Models/ReportTemplateViewModel';
import { ReportColumnModel } from '../Models/ReportColumnModel';
import { ReportTemplateColumnViewModel } from '../Models/ReportTemplateColumnViewModel';
import { ObjectsManagementDialogComponent } from '../../objects-management-dialog/objects-management-dialog.component';

@Component({
    selector: 'app-report-dialog-base',
    templateUrl: './report-dialog-base.component.html',
    styleUrls: ['./report-dialog-base.component.css'],
    standalone: false
})
export class ReportDialogBaseComponent extends DialogBaseComponent<ReportTemplateViewModel> {
  public columns: ReportColumnModel[] = [];
  public resColumns: ReportColumnModel[] = [];
  public reportTypes = new Map<number, string>();
  protected reportService: ReportTemplateService;
  @ViewChild("columnsListDialog", { read: ViewContainerRef, static: true }) objectsListContainer;
  private columnsListDialog: ComponentRef<any>;
  public dialogService = inject(DialogService);

  constructor(protected injector: Injector) {
    super(injector);
    this.reportService = injector.get(ReportTemplateService);
  }
  ngOnInit() {
    this.reportService.getReportTypes()
      .subscribe(types => {
        this.reportTypes = types;
      });

    this.onReportChange();
  }


  public get reportType(): string {
    return this.model.Type.toString();
  }

  public set reportType(value: string) {
    this.model.Type = parseInt(value);
  }


  private PrepareColumns(types: ReportColumnModel[]) {
    //reorder and set checkboxes
    types.forEach(el => {
      if (!el.Name)
        el.Name = this.translate.instant(el.Description);
      el.IsChecked = false
    });
  }
  public onReportChange() {
    this.reportService.getReportColumnTypes(this.model.Type)
      .subscribe(types => {
        let result: ReportColumnModel[] = [];

        this.PrepareColumns(types);

        for (let i = 0; i < this.model.Columns.length; i++) {
          var idx = types.findIndex(x => x.Type == this.model.Columns[i].Type);
          if (idx >= 0) {
            types[idx].Value = this.model.Columns[i].Value;
            types[idx].Name = this.model.Columns[i].Name == "" ? this.translate.instant(types[idx].Description) : this.model.Columns[i].Name;
            types[idx].IsChecked = true;

            let newObject = Object.assign({}, types[idx]);
            this.resColumns.push(newObject);
            //types.splice(idx, 1);
          }
        }
        result.push(...this.resColumns)

        types.forEach(type => {
          result.push(type);
        });


        this.columns = result;


        this.model.Type = <number>this.model.Type;
      });
  }

  public validate(): boolean {
    this.model.Columns = [];

    for (let i = 0; i < this.resColumns.length; i++) {
      var col = new ReportTemplateColumnViewModel();
      col.Type = this.resColumns[i].Type;
      col.Value = this.resColumns[i].Value;
      col.Name = this.resColumns[i].Name;
      this.model.Columns.push(col);
    }

    if (this.model.Name == "" || this.model.Name == undefined) {
      this.toastr.error(this.translate.instant('The name field is required'));
      return false;
    }
    if (this.model.Columns.length <= 0) {
      this.toastr.error(this.translate.instant('Choose columns'));
      return false;
    }
    return true;
  }

  public pullUp(el: ReportColumnModel) {
    var idx = this.resColumns.findIndex(x => x === el);
    if (idx > 0) {
      this.resColumns.splice(idx, 1);
      this.resColumns.splice(idx - 1, 0, el);
    }
  }

  public pullDown(el: ReportColumnModel) {
    var idx = this.resColumns.findIndex(x => x === el);
    if (idx < this.resColumns.length - 1) {
      this.resColumns.splice(idx, 1);
      this.resColumns.splice(idx + 1, 0, el);
    }
  }


  public openAddColumnDialog() {
    this.columnsListDialog = this.dialogService.open(this.objectsListContainer, ObjectsManagementDialogComponent);
    this.columnsListDialog.instance.isSingleItem = false;
    this.columns.forEach(x => x.IsChecked = false);
    this.columnsListDialog.instance.onOpen.subscribe(() => {
      this.reportService.getReportColumnTypes(this.model.Type)
        .subscribe(types => {
          this.PrepareColumns(types);
          this.columnsListDialog.instance.objects = types;
        });
    });
    this.columnsListDialog.instance.onSubmit.subscribe(() => {
      this.columnsListDialog.instance.objects.forEach(column => {
        if (column && column.IsChecked) {
          const clone = structuredClone(column);
          clone.IsChecked = false;
          this.resColumns.push(clone);
        }
        column.IsChecked = false;
      });
      this.columnsListDialog.instance.close();
    });
    this.columnsListDialog.instance.onClose.subscribe(() => {
    });
    this.columnsListDialog.instance.open();
  }

  public deleteColumn(column: ReportColumnModel) {
    const index = this.resColumns.indexOf(column);
    if (index > -1) {
      this.resColumns.splice(index, 1);
    }
  }
}
